/* tslint:disable */

export class BusinessDataProperty {
		Name: string;
		Value: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/BusinessDataProperty.ts